import { render, staticRenderFns } from "./PlatformReduction.vue?vue&type=template&id=21830b63&"
import script from "./PlatformReduction.vue?vue&type=script&lang=js&"
export * from "./PlatformReduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports